import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageInfo } from '../../../graphql/graphql';
import { AgencyListContainer } from './styled';
import { BusinessItemsListPageWrapper } from '../../BusinessItemsListPage';
import { AgencyListItem } from '../../BusinessItemsListPage/types';
import { useAgenciesList } from '../../../hooks/useAgenciesList';

interface AgenciesListProps {
  initialAgencies: AgencyListItem[];
  agenciesPageInfo: Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
  hasError: boolean;
}

export const AgenciesList: React.FC<AgenciesListProps> = ({
  initialAgencies,
  agenciesPageInfo,
  hasError
}) => {
  const { t } = useTranslation();
  const {
    displayItems,
    handleSearchQuery,
    isLoadingMore,
    isSearchPending,
    isStopLoad,
    onLoadMore
  } = useAgenciesList({ initialAgencies, agenciesPageInfo });

  return (
    <BusinessItemsListPageWrapper
      title={t('pages.agencies.title')}
      hasError={hasError}
      items={displayItems}
      onSearchQuery={handleSearchQuery}
      loading={isSearchPending}
      ListContainer={AgencyListContainer}
      onLoadMore={onLoadMore}
      isStopLoad={isStopLoad}
      isLoadingMore={isLoadingMore}
    />
  );
};
